import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: '100px',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px',
  },
}));

export default useStyles;
